import React, { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import styles from './Input.module.scss';

import { InputText, InputTextProps } from 'primereact/inputtext';
import c from 'clsx';
import clsx from 'clsx';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea';
import { Text } from '@components/Text';

type InputProps = {
  label?: string;
  labelHook: string;
  register?: any;
  required?: boolean;
  mask?: string;
  inputClassName?: string;
  textAreaProps?: InputTextareaProps;
  as?: 'input' | 'textarea';
  error?: ReactNode;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
} & InputTextProps;

export const Input: FC<InputProps> = (props) => {
  const {
    label,
    required,
    labelHook,
    inputClassName,
    disabled,
    register,
    as,
    textAreaProps,
    error,
    name,
  } = props;
  const [counter, setCounter] = useState(0);

  const handleTextAreaTextInput = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setCounter(event.target.value.length);
      textAreaProps?.onChange?.(event);
    },
    [textAreaProps]
  );

  const input = useMemo(() => {
    let fieldProps = {};
    if (register && name) {
      const registerResult = register(name, { required, disabled });
      fieldProps = {
        name,
        ref: registerResult.ref,
        onChange: registerResult.onChange,
        onBlur: registerResult.onBlur,
      };
    }
    if (as === 'textarea')
      return (
        <InputTextarea
          {...textAreaProps}
          {...fieldProps}
          id={`ticket-spot-text-input-${labelHook}`}
          className={c(styles.input, inputClassName)}
          onChange={handleTextAreaTextInput}
        />
      );
    if (props.mask)
      return (
        <InputMask
          {...props}
          {...fieldProps}
          id={`ticket-spot-text-input-${labelHook}`}
          className={c(styles.input, inputClassName)}
          mask={props.mask}
        />
      );
    return (
      <div className={styles.inputWrapper}>
        <div
          className={c(styles.iconWrapper, {
            [styles.leftPosition]: props.iconPosition === 'left',
            [styles.rightPosition]: props.iconPosition === 'right',
          })}
        >
          {props.icon}
        </div>
        <InputText
          {...props}
          {...fieldProps}
          id={`ticket-spot-text-input-${labelHook}`}
          className={c(
            styles.input,
            {
              [styles.withLeftIcon]: props.iconPosition === 'left',
              [styles.withRightIcon]: props.iconPosition === 'right',
            },
            inputClassName
          )}
        />
      </div>
    );
  }, [
    as,
    disabled,
    handleTextAreaTextInput,
    inputClassName,
    labelHook,
    name,
    props,
    register,
    required,
    textAreaProps,
  ]);

  return (
    <div className={c(styles.wrapper, props.className)}>
      <label
        htmlFor={`ticket-spot-text-input-${labelHook}`}
        className={clsx(styles.label, { [styles.withCounter]: as === 'textarea' })}
      >
        {label}
        {as === 'textarea' && (
          <Text variation="caption" thin color="black-100">{`${counter}/600`}</Text>
        )}
      </label>
      {input}
      {error}
    </div>
  );
};
